import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-student-list',
    templateUrl: './student-list.component.html',
    imports: [CommonModule,],
    styleUrls: ['./student-list.component.css']
})
export class StudentListComponent {
  @Input('vue') vue:any="list"
  @Input('datas') datas:any=[]
  @Output() launchEdittingEvent = new EventEmitter<any>();
  current:any


  launchEditting(el:any){
    this.launchEdittingEvent.emit(el);

  }
}
